export const userHasDefaultShipmentTags = ({companyTags, defaultShipmentTags}) => {
  return companyTags.length > 0 && defaultShipmentTags.length > 0;
};
